import { Container, CssBaseline } from '@material-ui/core';
import React, { createContext, lazy, Suspense, useState } from 'react';
 

import { Footer } from '@components/Footer';
import { Header } from '@components/Header';
import { Spinner } from '@components/Spinner';
import { useFullWidthPath, useHideLocalUrls, useSiteContext } from '@hooks';

// Lazy load conditional components
const PageBanner = lazy(() =>
  import('@components/Facebook').then((module) => ({ default: module.PageBanner })),
);

import useStyles from './styles';

export const SiteFooterContext = createContext<React.Dispatch<
  React.SetStateAction<boolean>
> | null>(null);

interface SiteLayoutProps {
  nav?: boolean;
  footer?: boolean;
  children?: React.ReactNode;
}

export const SiteLayout: React.FC<SiteLayoutProps> = ({ children, footer, nav = true }) => {
  const fullWidth = useFullWidthPath();
  const hideLocalUrls = useHideLocalUrls();
  const siteContext = useSiteContext();
  const [extraFooter, setExtraFooter] = useState(false);

  useStyles();

  return (
    <SiteFooterContext.Provider value={setExtraFooter}>
      <CssBaseline />
      {siteContext && (
        <Suspense fallback={null}>
          <PageBanner />
        </Suspense>
      )}
      <Header nav={nav} />
      <Container component="main" maxWidth={fullWidth ? false : 'lg'}>
        {siteContext ? <>{children}</> : <Spinner big />}
      </Container>
      {((!fullWidth && !hideLocalUrls) || footer || extraFooter) && <Footer />}
    </SiteFooterContext.Provider>
  );
};
